'use client';
import Sidebar from '@/components/Sidebar';
import Contact from './components/Contact';

export default function LienHePage(props) {
  const { rightBanners, linkPages, websiteCode } = props;

  return (
    <div className="flex flex-col min-h-screen">
      <div className="container mx-auto mt-5 flex-grow">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* ----- Cột Nội dung chính ----- */}
          <main className="lg:w-3/4 ">
            {/* Tiêu đề trang */}
            <Contact {...props} />
          </main>

          {/* ----- Cột Sidebar ----- */}
          <div className="w-full md:w-1/4 ">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </div>
        </div>
      </div>
    </div>
  );
}
